export enum UserRole {
  farmer = 'farmer',
  broker = 'broker',
  broker_farmer = 'broker_farmer',
  admin = 'admin'
}
